

<div class="page-content">
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="modal-header">
                    <!--//TODO: pasar todo al traductor-->
                    <h1>Invitar Potencial Receptor</h1>
                    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    Nombre
                                </label>
                                <input type="text" name="name" class="form-control text-uppercase"
                                       (keydown.space)="$event.preventDefault();"
                                       [(ngModel)]="newUserDocumentProcessTo.firstName " />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    Apellido
                                </label>
                                <input type="text" name="lastname" class="form-control text-uppercase"
                                       (keydown.space)="$event.preventDefault();"
                                       [(ngModel)]="newUserDocumentProcessTo.lastName" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="form-control-label">
                                    Email
                                </label>
                                <input type="text" name="email" class="form-control text-uppercase"
                                       (keydown.space)="$event.preventDefault();"
                                       [(ngModel)]="newUserDocumentProcessTo.Email" />
                            </div>
                        </div>
                        <div class="form-group col-12 m-0">
                            <label class="form-control-label">
                                Sintra Id
                            </label>
                            <input type="text" name="sintraId" class="form-control text-uppercase"
                                   (keydown.space)="$event.preventDefault();"
                                   [(ngModel)]="newUserDocumentProcessTo.sintraId" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer mt-3">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <app-button primary="true" [title]="'uploadInvite' | translate"
                                        [info]='translate.instant("uploadInvite")' (buttonClick)="uploadInvite()"
                                        [disable]="!isAbleToUpload()">
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
